export default "__VITE_ASSET__79jx$bfs__"